import { useEffect, useRef } from 'react';
import { Icon } from '../design/Icon';

/** Vrai si le focus est dans un champ de saisie ou un éditeur : on n'y détourne pas Cmd/Ctrl+K. */
function typingElsewhere(search: HTMLElement | null): boolean {
  const el = document.activeElement as HTMLElement | null;
  if (!el || el === search || el === document.body) return false;
  return el.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(el.tagName);
}

/**
 * Champ de recherche globale (pastille ⌘K). La recherche transverse n'existe pas encore (CLAUDE.md §14, étape 7) :
 * le champ et son raccourci sont en place, sans résultats.
 */
export function GlobalSearch() {
  const ref = useRef<HTMLInputElement>(null);
  const isMac = typeof navigator !== 'undefined' && /mac|iphone|ipad/i.test(navigator.platform || navigator.userAgent);

  useEffect(() => {
    const onKey = (e: KeyboardEvent): void => {
      if (e.key.toLowerCase() !== 'k' || !(e.metaKey || e.ctrlKey) || e.altKey || e.shiftKey) return;
      if (typingElsewhere(ref.current)) return;
      e.preventDefault();
      ref.current?.focus();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  return (
    <label className="sh-search">
      <Icon name="search" size={16} />
      <input ref={ref} type="search" placeholder="Rechercher" aria-label="Rechercher" aria-keyshortcuts={isMac ? 'Meta+K' : 'Control+K'} />
      <kbd className="sh-kbd" aria-hidden="true">{isMac ? '⌘K' : 'Ctrl K'}</kbd>
    </label>
  );
}
